import { StatsigClient as SDKClient } from "@statsig/js-client";

export const SESSION_COOKIE = "session-id";

export type BuiltUser = {
  user: StatsigSdkUser;
  tier: string;
  sessionId?: string;
};

export type StatsigSdkUser = {
  userID?: string;
  email?: string;
  custom?: Record<string, string>;
};

export type StatsigState = {
  client: SDKClient | null;
  initPromise: Promise<void> | null;
  initialized: boolean;
  isReady: boolean;
};

export const state: StatsigState = {
  client: null,
  initPromise: null,
  initialized: false,
  isReady: false,
};

export interface StatsigUserContext {
  userID?: number;
  ccoId?: string;
  email?: string;
  sessionId?: string;
}

export interface UserStatus {
  userId?: number;
  cco_id?: string;
  email?: string;
}

export interface StatsigGateContextOptions {
  isUnauth: () => boolean;
  statusGetter: () => UserStatus | null | undefined;
}

export interface CheckGateOptions {
  gateName: string;
  fallback?: boolean;
}

export interface StatsigReader {
  get<T>(key: string, fallback: T): T;
  value?: Record<string, unknown>;
}

export const EMPTY_READER: StatsigReader = {
  get: (_key, fallback) => fallback,
  value: {},
};
